import React from "react";
import "./App.css";
import Home from "./Home";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Access from "./Access";
import Discovery from "./Discovery";
import DiscoveryActivityTimeline from "./DiscoveryActivityTimeline";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/access/:qrCodeID",
    element: <Access />,
  },
  {
    path: "/themes/:themeID/discoveries/next",
    element: <Discovery />,
  },
  {
    path: "/themes/:themeID/discoveries/stats/timeline",
    element: <DiscoveryActivityTimeline />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
